import { retryWhen, share, filter, scan, map, debounceTime, takeUntil } from 'rxjs/operators';
import { Observable, Subscriber } from 'rxjs';
import { setPubsubStream, errorHandler } from '../apiHelper';
import { ARCSolutions, ProcessType, Healthcheck, GroupedHealthcheckSolution, AWRCParameters, BALParameters, ProcessLine } from '../../types';
import { default as lodashMerge } from 'lodash/merge';
import { getFactoryChangeObservable } from '../../Auth';
import { withLogger } from '../LogerServices';

const HealthcheckObserver: { HealthcheckObservable: Observable<Healthcheck> } = {
    HealthcheckObservable: null as Observable<Healthcheck>,
};

const setHealthcheckStream = () => new Observable<Healthcheck>((observer: Subscriber<Healthcheck>) => {
    const close = setPubsubStream(observer, ProcessType.HEALTHCHECK);
    return close;
}).pipe(
    retryWhen(errorHandler),
    takeUntil(getFactoryChangeObservable()),
    share()
);

const HealthcheckDataObservable = () => {
    HealthcheckObserver.HealthcheckObservable = withLogger(setHealthcheckStream(), ProcessType.HEALTHCHECK).pipe(
        share()
    );
    return HealthcheckObserver.HealthcheckObservable
};

const getHealthcheckDataObservable = (): Observable<Healthcheck> =>
    HealthcheckObserver.HealthcheckObservable
        ? HealthcheckObserver.HealthcheckObservable
        : HealthcheckDataObservable();

export const getARCSolutionHealthcheckObservable = (solution: ARCSolutions, line: string = '') => getHealthcheckDataObservable().pipe(
    filter(data => {
        if ([ARCSolutions.BS, ARCSolutions.BC].includes(solution)) {
            return data.solution === `${solution}_${line}`;
        }
        return data.solution === solution
    }),
);

export const getADCSolutionHealthcheckObservable = () => getHealthcheckDataObservable().pipe(
    filter(data => data.solution === ProcessType.ADC),
);

export const getCDSSolutionHealthcheckObservable = () => getHealthcheckDataObservable().pipe(
    filter(data => data.solution === ProcessType.CDS),
);

export const getAWRCSolutionHealthcheckObservable = (solution: AWRCParameters) => getHealthcheckDataObservable().pipe(
    filter(data => data.solution === `${ProcessType.AWRC}_${solution}`),
);

export const getBALSolutionHealthcheckObservable = (solution: BALParameters, line: ProcessLine) => getHealthcheckDataObservable().pipe(
    filter(data => data.solution === `${ProcessType.BAL}_${solution}_${line}`),
);

export const getAlarmHealthcheckObservable = () => getHealthcheckDataObservable().pipe(
    filter(data => data.alarmType !== undefined),
);

export const getALCHealthcheckStreamObservable = (): Observable<Healthcheck[]> => getHealthcheckDataObservable().pipe(
    map(data => ({ [data.solution]: data })),
    scan((acc, val) => lodashMerge({}, acc, val), {} as GroupedHealthcheckSolution),
    debounceTime(100),
    map(data => Object.values(data))
);